export const copy = {
  areas: {
    title: "Our Service Areas",
    sub: "We provide professional cleaning services across greater Sydney suburbs.",
    featured: [
      {
        name: "Eastern Suburbs",
        slug: "eastern-suburbs",
        postcode: "2021",
        tagline: "Complete cleaning solutions for the Eastern Suburbs.",
        description:
          "Our Eastern Suburbs team delivers top-tier residential and commercial cleaning across suburbs like Bondi, Randwick, Maroubra and more.",
        lat: -33.8928,
        lng: 151.2643,
        coverageDetails: [
          { name: "Bondi", note: "Premium beachside cleaning services" },
          { name: "Coogee", note: "Coastal property specialists" },
          { name: "Maroubra", note: "Residential and commercial cleaning" },
          { name: "Double Bay", note: "Luxury property maintenance" },
          { name: "Rose Bay", note: "Harbourside cleaning experts" },
          { name: "Vaucluse", note: "High-end residential services" },
          { name: "Woollahra", note: "Heritage property care" },
          { name: "Paddington", note: "Terrace house specialists" },
        ],
        coverageSuburbs: [
          "Bondi","Coogee","Maroubra","Double Bay","Rose Bay","Vaucluse","Woollahra","Paddington",
        ],
      },
      {
        name: "Northern Beaches",
        slug: "northern-beaches",
        postcode: "2095",
        tagline: "Trusted cleaning services for the Northern Beaches.",
        description:
          "From Manly to Palm Beach, our expert cleaners ensure your coastal home stays fresh and sparkling.",
        lat: -33.7980,
        lng: 151.2874,
        coverageDetails: [
          { name: "Manly", note: "Beachfront property experts" },
          { name: "Dee Why", note: "Northern beaches specialists" },
          { name: "Avalon", note: "Premium coastal cleaning" },
          { name: "Palm Beach", note: "Exclusive beachside service" },
          { name: "Mona Vale", note: "Comprehensive cleaning solutions" },
          { name: "Freshwater", note: "Local beach community service" },
          { name: "Curl Curl", note: "Residential cleaning experts" },
          { name: "Narrabeen", note: "Family home specialists" },
        ],
        coverageSuburbs: [
          "Manly","Dee Why","Avalon","Palm Beach","Mona Vale","Freshwater","Curl Curl","Narrabeen",
        ],
      },
      {
        name: "North Shore",
        slug: "north-shore",
        postcode: "2064",
        tagline: "Premium cleaning services across the North Shore.",
        description:
          "Serving Chatswood, Mosman, Lane Cove and beyond with professional residential and commercial cleans.",
        lat: -33.7970,
        lng: 151.1837,
        coverageDetails: [
          { name: "Chatswood", note: "Commercial and residential hub" },
          { name: "Lane Cove", note: "Leafy suburb specialists" },
          { name: "North Sydney", note: "Business district cleaning" },
          { name: "Mosman", note: "Premium harbour views" },
          { name: "Neutral Bay", note: "Harbourside apartments" },
          { name: "Cremorne", note: "Waterfront property care" },
          { name: "Willoughby", note: "Family suburb cleaning" },
          { name: "Artarmon", note: "Residential and office cleaning" },
        ],
        coverageSuburbs: [
          "Chatswood","Lane Cove","North Sydney","Mosman","Neutral Bay","Cremorne","Willoughby","Artarmon",
        ],
      },
      {
        name: "Inner West",
        slug: "inner-west",
        postcode: "2042",
        tagline: "Reliable cleaning solutions for the Inner West.",
        description:
          "From Newtown to Marrickville and Leichhardt, our team brings thorough, dependable cleaning to your doorstep.",
        lat: -33.9005,
        lng: 151.1643,
        coverageDetails: [
          { name: "Newtown", note: "Creative quarter cleaning" },
          { name: "Leichhardt", note: "Italian heritage area" },
          { name: "Balmain", note: "Historic harbour suburb" },
          { name: "Rozelle", note: "Trendy inner west hub" },
          { name: "Glebe", note: "Student and family area" },
          { name: "Surry Hills", note: "Urban apartment specialists" },
          { name: "Redfern", note: "Cultural district cleaning" },
          { name: "Marrickville", note: "Multicultural community service" },
        ],
        coverageSuburbs: [
          "Newtown","Leichhardt","Balmain","Rozelle","Glebe","Surry Hills","Redfern","Marrickville",
        ],
      },
      {
        name: "South Sydney",
        displayName: "Southern Sydney", // for UI titles
        slug: "south-sydney",
        postcode: "2032",
        tagline: "Expert cleaning services for South Sydney.",
        description:
          "Covering Coogee, Maroubra, Mascot and more with deep cleans and maintenance services.",
        lat: -33.9230,
        lng: 151.2628,
        coverageDetails: [
          { name: "Cronulla", note: "Beach suburb specialists" },
          { name: "Sutherland", note: "Shire area headquarters" },
          { name: "Hurstville", note: "Commercial district cleaning" },
          { name: "Kogarah", note: "St George area service" },
          { name: "Rockdale", note: "Industrial and residential" },
          { name: "Miranda", note: "Shopping hub specialists" },
          { name: "Caringbah", note: "Family suburb cleaning" },
          { name: "Engadine", note: "Growing residential area" },
        ],
        coverageSuburbs: [
          "Cronulla","Sutherland","Hurstville","Kogarah","Rockdale","Miranda","Caringbah","Engadine",
        ],
      },
      {
        name: "Western Sydney",
        slug: "western-sydney",
        postcode: "2153",
        tagline: "Comprehensive cleaning across Western Sydney.",
        description:
          "Serving Penrith, Blacktown, and surrounding areas with reliable residential and commercial cleaning.",
        lat: -33.7513,
        lng: 150.6900,
        coverageDetails: [
          { name: "Parramatta", note: "Major business district" },
          { name: "Blacktown", note: "Growing suburban area" },
          { name: "Liverpool", note: "Diverse community hub" },
          { name: "Penrith", note: "Western gateway cleaning" },
          { name: "Mount Druitt", note: "Family suburb specialists" },
          { name: "Fairfield", note: "Multicultural area service" },
          { name: "Bankstown", note: "Commercial and residential" },
          { name: "Auburn", note: "Community-focused cleaning" },
        ],
        coverageSuburbs: [
          "Parramatta","Blacktown","Liverpool","Penrith","Mount Druitt","Fairfield","Bankstown","Auburn",
        ],
      },
      {
        name: "Hills District",
        slug: "hills-district",
        postcode: "2155",
        tagline: "Professional cleaning solutions in the Hills District.",
        description:
          "From Castle Hill to Kellyville, our experienced team ensures pristine results every time.",
        lat: -33.7550,
        lng: 150.9880,
        coverageDetails: [
          { name: "Castle Hill", note: "Family-friendly cleaning" },
          { name: "Hornsby", note: "Bushland suburb care" },
          { name: "Ryde", note: "Riverside property service" },
          { name: "Epping", note: "Growing family area" },
          { name: "Carlingford", note: "Premium residential cleaning" },
          { name: "West Pennant Hills", note: "Leafy hills suburb" },
          { name: "Thornleigh", note: "Natural bush setting" },
          { name: "Wahroonga", note: "Upper north shore luxury" },
        ],
        coverageSuburbs: [
          "Castle Hill","Hornsby","Ryde","Epping","Carlingford","West Pennant Hills","Thornleigh","Wahroonga",
        ],
      },
      
     
    ],
    cta: { label: "View All Service Areas" }
  },

  nav: [
    { href: "/#services", label: "Services" },
    { href: "/areas",     label: "Areas" },
    { href: "/gallery",   label: "Gallery" },
    { href: "/about",     label: "About" },
    { href: "/contact",   label: "Contact" },
    { href: "/blog",      label: "Blog" }
  ],
  // Unused (no component reads copy.topbar - the marquee topbar this was
  // written for isn't part of the current Header design). Kept for shape
  // parity; the phone number was hardcoded rather than settings-sourced,
  // so it's removed here rather than left to go stale if this is ever
  // wired back up.
  topbar: [
    "Limited Time: Same-Day Service Available",
    "5-Star Rated Service • Fully Insured",
    "📞 Same-Day Service Available",
  ],
  hero: {
    eyebrow: "Melbourne Registered • Sydney Operating",
    headline: "Sydney's #1 Professional",
    headlineStrong: "Cleaning Services",
    sub: "Solar Panels • Roofs & Gutters • Windows • Pressure Washing",
    badges: ["Same-Day Service Available","Fully Insured & Licensed","100% Satisfaction Guarantee"],
    // Currently unused (no component reads copy.hero.metrics) - kept for
    // shape parity if a future hero layout wants a metrics row. "200+
    // Reviews"/"1000+ This Year" used to sit here as invented numbers;
    // real figures live in Admin > Website Settings (googleReviewCount,
    // customersServed) and must be read from there, not hardcoded here,
    // if this ever gets wired up.
    metrics: [
      { label: "Fully Insured", value: "$10M Coverage" },
      { label: "5-Star Rated", value: "Google Reviews" },
      { label: "Happy Customers", value: "Sydney-Wide" },
      { label: "ABN Licensed", value: "Verified Business" },
    ],
    ctaPrimary:  { label: "Get Free Quote Now", href: "/contact" },
    // Unused (no component reads copy.hero.ctaSecondary) - see lib/phone.js
    // for the real, settings-driven phone link pattern used everywhere
    // this actually renders.
    ctaSecondary:{ label: "Call Us Now", href: "/contact" },
    image: { src: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", alt: "Professional cleaning service in action" },
    logo:  { src: "https://images.unsplash.com/photo-1563298723-dcfebaa392e3?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80", alt: "Horizon Solar & Exterior Care Logo" },
  },
  servicesIntro: {
    title: "Solar Cleaning + Thermal Inspection, Backed by Full Exterior Care",
    sub: "We combine professional exterior cleaning with advanced solar inspection technology — solar comes first, everything else above the roofline follows.",
  },
  // Priority order matters here - this array drives both the homepage
  // Services section and the Packages section, in that order:
  // 1. Solar (flagship, primary) · 2. Roof · 3. Concrete · then extras.
  services: [
    {
      slug: "solar-cleaning-maintenance",
      title: "Solar Panel Cleaning + Thermal Health Scan",
      flagship: true,
      primary: 1,
      badge: "Flagship Service",
      catchline: "Bring Your Solar Back to Life",
      blurb: "Expert water-fed pole solar panel cleaning combined with a radiometric drone thermal pass — lifts energy output and flags soiling or hotspots a visual check would miss.",
      bullets: [
        "Professional water-fed pole panel cleaning",
        "DJI Matrice 4T thermal drone scan",
        "Hotspot & soiling detection",
        "Warranty-safe cleaning technique",
        "12+ Point Solar Health Check",
      ],
      healthCheck: "12+ Point Solar Health Check",
      icon: "Sun",
      image: "/images/solar.avif",
      ctaLabel: "View Solar Package",
    },
    {
      // Kept the original "drone-based-washing" slug as a distinct detail
      // page (redirects to the combined solar service on the homepage),
      // so any existing external links keep working - see App.js.
      slug: "roof-gutter-cleaning",
      title: "Roof Cleaning",
      flagship: false,
      primary: 2,
      catchline: "Moss, Lichen and Grime — Gone",
      blurb: "Professional roof cleaning that removes moss, lichen and weather staining and protects your property from water damage — gutters cleared as part of the same visit.",
      bullets: [
        "Moss, lichen & organic growth removal",
        "Weather staining treated",
        "Gutters cleared of debris",
        "Prevents water damage",
      ],
      icon: "Home",
      image: "/images/hero2.jpg",
      galleryImage: "/images/drone-sequence/scene-2-rising.webp",
      ctaLabel: "View Roof Package",
    },
    {
      // Renamed from "Pressure Washing" - same underlying service, clearer
      // name matching the concrete/driveway/patio work it actually covers.
      // Old slug kept working via a redirect in App.js.
      slug: "concrete-cleaning",
      title: "Concrete Cleaning",
      flagship: false,
      primary: 3,
      catchline: "Driveways, Paths & Patios Refreshed",
      blurb: "Restore driveways, paths, patios and other concrete surfaces to like-new condition, removing built-up dirt, staining and grime.",
      bullets: [
        "Driveways, paths & patios",
        "Built-up dirt & staining removed",
        "All concrete surface types",
        "Eco-friendly process",
      ],
      icon: "Droplets",
      image: "/images/pressure.webp",
      // Separate from `image` (used on the service's own detail page, where
      // a literal ground-level shot of the work makes sense) - the homepage
      // gallery wants the same aerial-rooftop photography as everywhere
      // else on the site, not a mismatched stock photo.
      galleryImage: "/images/drone-sequence/scene-3-elevated.webp",
      ctaLabel: "View Concrete Package",
    },
    {
      slug: "window-cleaning",
      title: "Window Cleaning",
      blurb: "Crystal clear windows for homes and businesses across Sydney.",
      bullets: ["Streak-free results", "Inside & outside", "Regular maintenance"],
      icon: "Square",
      image: "/images/window.jpg",
      galleryImage: "/images/drone-sequence/scene-4-isometric.webp",
    },
  ],
  process: {
    title: "Why Choose Horizon Solar & Exterior Care?",
    subtitle: "Professional, reliable, and committed to exceeding expectations every time",
    cards: [
      { title: "Melbourne Registered", text: "Licensed, insured and trusted professionals operating across Sydney", icon: "Shield" },
      { title: "Same-Day Service", text: "Fast response when you need it most - available 7 days a week", icon: "Clock" },
      { title: "100% Guarantee", text: "Complete satisfaction guaranteed or we'll return to make it right", icon: "CheckCircle" },
      // Process.jsx always overrides this card's title with a real,
      // settings-sourced figure (or a neutral fallback) at render time -
      // see the Star-icon check there - so the literal text below never
      // actually reaches a visitor, but is kept non-numeric anyway so a
      // stale-looking invented count doesn't sit in source unexplained.
      // Process.jsx always overrides both title and text for this card
      // with real, settings-sourced values (or a neutral fallback) at
      // render time - see the Star-icon check there.
      { title: "Highly Rated Service", text: "Trusted service across all Sydney suburbs, growing daily", icon: "Star" },
    ],
  },
  testimonials: {
    title: "What Sydney Customers Say",
    // Unused (Testimonials.jsx sources rating/count from Admin > Website
    // Settings > Google Business Profile, not from here) - kept
    // non-numeric rather than deleted, in case future copy changes ever
    // read these fields again.
    rating: "5.0 Stars",
    sub: "Real reviews from real Sydney customers",
    items: [
      { name:"Sarah M.", location:"Bondi",
        text:"Had my solar panels cleaned by Horizon Solar & Exterior Care and couldn't be happier! They increased our energy output by 28% and were incredibly professional throughout. Highly recommend to anyone wanting to maximize their solar investment." },
      { name:"Michael T.", location:"Chatswood",
        text:"Absolutely fantastic pressure washing service! My concrete driveway looked terrible after years of stains and weathering. Now it looks like we have a brand new driveway. Professional, punctual and worth every penny!" },
      { name:"Lisa K.", location:"Manly",
        text:"Called Horizon for an urgent roof and gutter clean before the storm season. They came same-day, cleared everything perfectly and potentially saved us from serious water damage. Professional service at its absolute best!" },
    ],
  },
  gallery: {
    title: "Before & After Results",
    subtitle: "See the dramatic difference our professional cleaning makes",
    images: [
      { src:"https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80", alt:"Driveway pressure washing before and after", caption: "Driveway Pressure Washing" },
      { src:"https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80", alt:"House exterior cleaning result", caption: "House Exterior Cleaning" },
      { src:"https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80", alt:"Roof cleaning professional result", caption: "Roof & Gutter Cleaning" },
      { src:"https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80", alt:"Window cleaning crystal clear result", caption: "Window Cleaning" },
      { src:"https://images.unsplash.com/photo-1582719508461-905c673771fd?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80", alt:"Patio pressure cleaning transformation", caption: "Patio Cleaning" },
      { src:"https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80", alt:"Commercial facade cleaning", caption: "Commercial Cleaning" },
      { src:"https://images.unsplash.com/photo-1628744448840-55bdb2497bd4?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80", alt:"Solar panel cleaning efficiency", caption: "Solar Panel Cleaning" },
      { src:"https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80", alt:"Gutter clearing and cleaning", caption: "Gutter Maintenance" },
      { src:"https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80", alt:"Pavers restored to original condition", caption: "Paver Restoration" },
    ],
  },
  faq: {
    title:"Frequently Asked Questions",
    items: [
      { q: "Do you provide same-day service?", a: "Yes! We offer same-day service across most Sydney suburbs, subject to availability. Contact us before 2 PM for potential same-day scheduling." },
      { q: "Are you fully insured?", a: "Absolutely. We carry $10 million public liability insurance and full workers compensation coverage. All our technicians are licensed and insured." },
      { q: "What's included in your satisfaction guarantee?", a: "If you're not completely satisfied with our work, we'll return at no extra charge to make it right. Your satisfaction is 100% guaranteed." },
      { q: "Do you clean solar panels safely?", a: "Yes, we use specialized soft-brush techniques and deionized water to safely clean solar panels without voiding manufacturer warranties. All work maintains compliance." },
      { q: "How often should I have my gutters cleaned?", a: "We recommend gutter cleaning every 6-12 months, or more frequently if you have overhanging trees. Regular maintenance prevents water damage and costly repairs." }
    ]
  },
  cta: {
    line: "Ready for Professional Results?",
    subline: "Free Quotes • Same Day Service Available • 100% Satisfaction Guaranteed",
    button: { label:"Get Free Quote Now", href:"/contact" },
    // Unused (no component reads copy.cta.phone) - CTA.jsx renders its
    // own hardcoded copy independent of this whole `cta` object.
    phone:  { label:"Call Us Now", href:"/contact" },
  },
  about: {
    title: "About Horizon Solar & Exterior Care",
    subtitle: "Sydney's Most Trusted Professional Cleaning Service",
    body: `We're a Melbourne registered, Sydney operating professional cleaning service committed to delivering exceptional results that protect and enhance your property value.

We've built our reputation on reliability, professionalism, and results that exceed expectations. Our team uses only the best equipment and techniques to ensure every job meets our high standards.

Whether it's solar panel cleaning to boost your energy efficiency, roof and gutter maintenance to prevent water damage, crystal-clear window cleaning, or pressure washing to restore your outdoor surfaces - we deliver professional results with a 100% satisfaction guarantee.

Licensed, insured, and available 7 days a week with same-day service options.`,
    image: { src:"https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", alt:"Professional cleaning team at work" },
    features: [
      "Melbourne Registered Business",
      "$10M Public Liability Insurance",
      "Licensed & Certified Technicians",
      "Same-Day Service Available",
      "100% Satisfaction Guarantee",
      "Eco-Friendly Cleaning Methods"
    ]
  },
  contact: {
    title: "Get Your Free Quote",
    sub: "Tell us about your cleaning needs and we'll provide a detailed quote within 24 hours. Same-day service available across Sydney.",
    consent: "I agree to be contacted about my cleaning service enquiry via phone, email or SMS.",
    success: "Thanks! We've received your request and will contact you within 2 hours during business hours.",
    error: "Something went wrong. Please try calling us directly on 02 8000 1080 or try again.",
    businessHours: "Monday to Saturday: 8:00 AM - 6:00 PM",
    emergencyNote: "For urgent same-day requests, please call directly: 02 8000 1080"
  },
};